module.exports = __webpack_public_path__ + "static/media/union.1799e1e5.svg";